module.exports = __webpack_public_path__ + "img/problems-1.7c81b849.png";